import { TextButton } from "components/textButton/TextButton";
import classNames from "classnames";

export type HomePageSectionHeaderProps = {
  title?: string;
  buttonText?: string;
  buttonUrl?: string;
  onButtonClick?: () => void | Promise<void>;
  buttonClassName?: string;
  className?: string;
  theme?: "default" | "pro" | "sifted";
  "data-testid"?: string;
};

const themeStyles = {
  default: {
    border: "border-black-rock",
    title: "text-black-rock",
    variant: "neutral" as const,
  },
  pro: {
    border: "border-brand-pro",
    title: "text-brand-pro",
    variant: "pro" as const,
  },
  sifted: {
    border: "border-brand-sifted",
    title: "text-brand-sifted",
    variant: "sifted" as const,
  },
} as const;

const HomePageSectionHeader: React.FC<HomePageSectionHeaderProps> = ({
  title,
  buttonText,
  buttonUrl,
  onButtonClick,
  buttonClassName,
  className,
  theme = "default",
  "data-testid": dataTestId,
}) => {
  const { border, title: titleColor, variant } = themeStyles[theme];

  return (
    <div
      className={classNames(
        "flex flex-col items-center justify-start border-b pb-4",
        border,
        className
      )}
      data-testid={dataTestId}
    >
      <div className="flex w-full flex-row flex-wrap items-center justify-between gap-4">
        {title && (
          <h3 className={classNames("font-emphasis-18", titleColor)}>
            {title}
          </h3>
        )}
        <div>
          {buttonText && buttonUrl && (
            <TextButton
              label={buttonText}
              href={buttonUrl}
              onClick={onButtonClick}
              variant={variant}
              iconPosition="right"
              className={buttonClassName || "ga-briefing-pro-link w-fit"}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default HomePageSectionHeader;
